// https://stackoverflow.com/a/6267742
// https://stackoverflow.com/a/31663645

export function dataUriToFile(dataUri: string, fileName: string, mimeType: string): File {
	const blob = dataUriToBlob(dataUri);

	return new File([blob], fileName, { type: mimeType });
}

/*
The MIT License (MIT)
Copyright (c) 2016 David Gomez-Urquiza
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
function dataUriToBlob(dataUri: string): Blob {
	// convert base64 to raw binary data held in a string
	const byteString = atob(dataUri.split(',')[1]);

	// separate out the mime component
	const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

	// write the bytes of the string to an ArrayBuffer
	const arrayBuffer = new ArrayBuffer(byteString.length);
	const _ia = new Uint8Array(arrayBuffer);
	for (let i = 0; i < byteString.length; i++) {
		_ia[i] = byteString.charCodeAt(i);
	}

	const dataView = new DataView(arrayBuffer);
	const blob = new Blob([dataView], { type: mimeString });
	return blob;
}
